<template>
  <section ref="rootEl" id="tech-advantages" class="section" data-component="tech-metrics">
    <LazyBg :src="bgSrc" />
    <div class="container metrics-layout">
      <div class="metrics-intro reveal">
        <span class="card-tag">技术实力</span>
        <h2 class="metrics-title">以数据见证<br />算力规模</h2>
      </div>

      <div class="metrics-grid reveal reveal-delay-1">
        <div
          v-for="(item, i) in metrics"
          :key="item.label"
          class="metric-item"
          :class="item.delayClass"
        >
          <div class="metric-value">{{ display[i] }}</div>
          <div class="metric-label">{{ item.label }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import LazyBg from '@/components/LazyBg.vue';
import { useCountUp, type MetricTarget } from '@/composables/useCountUp';
import bgSrc from '@/assets/home_bg2.jpg';
import '@/styles/newhome/home/metrics.css';

const rootEl = ref<HTMLElement | null>(null);

const metrics: MetricTarget[] = [
  { count: 32, suffix: '', label: '算力覆盖省/自治区/直辖市', delayClass: 'reveal-delay-1' },
  { count: 882, suffix: '+', label: '服务器集群规模', delayClass: 'reveal-delay-2' },
  { count: 99, suffix: '.99%', label: '系统可用性SLA', delayClass: 'reveal-delay-3' },
  { count: 7, suffix: 'x24h', label: '全天候运维响应', delayClass: 'reveal-delay-1' }
];

const { display } = useCountUp(rootEl, metrics);
</script>
